/*
 What every logo component draws with, and the one thing none of them may import: the table of all
 ten logos.

 A logo is 6KB of geometry on average. `[mib-logo]` picks its drawing by name, so it has to hold the
 whole table and an application that shows one mark downloads all of them. The per-logo components
 exist for that reason — `<svg mib-logo-ai>` reaches exactly one definition, and a bundler drops the
 nine it never named. They can only keep that promise if what they share, the base class, lives
 somewhere that knows nothing about `MIB_LOGO_DATA`. That is here; the template is `logo.component.html`.

 Types are the exception: they are erased before a bundler ever sees the file, so importing them
 from `logo.data.ts` costs nothing.
*/

/** The base class of a logo, shared with `[mib-icon]`'s sizing rules through `mib-logo-default-size`. */
export const MIB_LOGO_CLASS = 'mib-logo-default-size w-auto fill-current transition-colors';

/**
 * @deprecated The logos draw from `logo.component.html`; kept so the public API does not change.
 */
export const MIB_LOGO_TEMPLATE = `
  @for (shape of definition().shapes; track $index) {
    <svg:path
      [attr.d]="shape.d"
      [attr.fill-rule]="shape.fillRule"
      [attr.clip-rule]="shape.clipRule"
      [attr.fill]="shape.fill" />
  }
`;
